export class UserAppSettings {
    userName = '';
    orgName = '';

    constructor(input?: Partial<UserAppSettings>) {
        if (input) Object.assign(this, input);
    }
}
